import { render, staticRenderFns } from "./SongSearch.vue?vue&type=template&id=06018b01&"
import script from "./SongSearch.vue?vue&type=script&lang=ts&"
export * from "./SongSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports